export function minutesToHHMM(totalMinutes: number) {
    const hours = Math.floor(totalMinutes / 60)
    const minutes = Math.floor(totalMinutes) % 60
  
    const unit = ['h', 'min'];
    return [hours, minutes]
      .map((v, i) => (v < 10 ? "0" + v : v) + unit[i])
      .filter((v, i) => v !== "00" || i > 0)
      .join(":")
  }